import React, { useState } from "react";
import { compose, graphql, Query } from "react-apollo";
import { Modal } from "react-responsive-modal";
import { Badge, Row, Col } from "react-bootstrap";
import Confirm from "../Dialog/Confirm";
import NewProduitModal from "./Modal/NewProduitModal";
import RenameProduitModal from "./Modal/RenameProduitModal";
import RenameCategorieModal from "./Modal/RenameCategorieModal";
import NewCategorieModal from "./Modal/NewCategorieModal";
import { getPlan } from "../../../api/queries/plan.queries";
import {
  addProduit,
  removeProduit,
  renameProduit,
  addCategorie,
  removeCategorie,
  renameCategorie
} from "../../../api/queries/plan.mutations";
import Loader from "../Loader";
import { useAuthState } from "../../Context";
import { notify } from "../../generic";
import { login, register } from "../../../api/queries/utilisateur.mutations";
import { Item, Menu, Submenu, useContextMenu } from "react-contexify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag, faTrashAlt, faGear } from "@fortawesome/free-solid-svg-icons";

function PlanExploitation(props) {
  const [newProduitDialogOpen, setNewProduitDialogOpen] = useState(false);
  const [renameProduitDialogOpen, setRenameProduitDialogOpen] = useState(false);
  const [removeProduitDialogOpen, setRemoveProduitDialogOpen] = useState(false);
  const [newCategorieDialogOpen, setNewCategorieDialogOpen] = useState(false);
  const [renameCategorieDialogOpen, setRenameCategorieDialogOpen] = useState(
    false
  );
  const [removeCategorieDialogOpen, setRemoveCategorieDialogOpen] = useState(
    false
  );
  const [categorieName, setCategorieName] = useState("");
  const [categorieId, setCategorieId] = useState(null);
  const [profit, setProfit] = useState(true);
  const [produitName, setProduitName] = useState(null);
  const [produitNewName, setProduitNewName] = useState(null);
  const [newProduitLoading, setNewProduitLoading] = useState(false);
  const [newCategorieLoading, setNewCategorieLoading] = useState(false);
  const [renameCategorieLoading, setRenameCategorieLoading] = useState(false);
  const [renameProduitLoading, setRenameProduitLoading] = useState(false);
  const [hoveringProduit, setHoveringProduit] = useState(null);
  const [hoveringCategorie, setHoveringCategorie] = useState(null);
  const [selectedProduit, setSelectedProduit] = useState({
    id: null,
    name: null,
    categorie: null
  });
  const [selectedCategorie, setSelectedCategorie] = useState({
    id: null,
    name: null
  });

  const _mutateAddProduit = async ({
    planId,
    categorieId,
    produitName,
    refetch
  }) => {
    try {
      setNewProduitLoading(true);
      return props
        .addProduit({
          variables: {
            planId,
            categorieId,
            produitName
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.addProduit;

          refetch();
          return { type, message, details };
        })
        .finally(() => setNewProduitLoading(false));
    } catch (error) {
      console.log(error);
      notify("error", error.message);

      return { type: "error", message: error.message, details: error };
    }
  };

  const _mutateRenameProduit = async ({
    planId,
    categorieId,
    produitNewName,
    produitId,
    refetch
  }) => {
    try {
      return props
        .renameProduit({
          variables: {
            planId,
            categorieId,
            produitId,
            produitNewName
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.renameProduit;

          refetch();
          return { type, message, details };
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);

      return { type: "error", message: error.message, details: error };
    }
  };

  const _mutateRemoveProduit = async ({
    planId,
    categorieId,
    produitId,
    refetch
  }) => {
    try {
      return props
        .removeProduit({
          variables: {
            planId,
            categorieId,
            produitId
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.removeProduit;

          refetch();
          return { type, message, details };
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);

      return { type: "error", message: error.message, details: error };
    }
  };

  const _mutateAddCategorie = async ({ planId, categorieName, refetch }) => {
    try {
      setNewCategorieLoading(true);

      return props
        .addCategorie({
          variables: {
            planId,
            profit,
            categorieName
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.addCategorie;

          refetch();
          return { type, message, details };
        })
        .finally(() => setNewCategorieLoading(false));
    } catch (error) {
      console.log(error);
      notify("error", error.message);

      return { type: "error", message: error.message, details: error };
    }
  };

  const _mutateRenameCategorie = async ({
    planId,
    categorieId,
    categorieNewName,
    refetch
  }) => {
    try {
      setRenameCategorieLoading(true);
      return props
        .renameCategorie({
          variables: {
            planId,
            categorieId,
            categorieNewName
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.renameCategorie;

          refetch();
          return { type, message, details };
        })
        .finally(() => {
          setRenameCategorieLoading(false);
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);

      return { type: "error", message: error.message, details: error };
    }
  };

  const _mutateRemoveCategorie = async ({ planId, categorieId, refetch }) => {
    try {
      return props
        .removeCategorie({
          variables: {
            planId,
            categorieId
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.removeCategorie;

          refetch();
          return { type, message, details };
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);

      return { type: "error", message: error.message, details: error };
    }
  };

  const handleNewProduitModalOpenning = ({ categorie }) => {
    const { name, id } = categorie;
    setCategorieName(name);
    setCategorieId(id);
    setNewProduitDialogOpen(true);
  };

  const handleRenameProduitModalOpenning = () => {
    const { name, id } = selectedProduit;

    setRenameProduitDialogOpen(true);
  };

  const handleRemoveProduitModalOpenning = () => {
    const { name, id } = selectedProduit;

    setRemoveProduitDialogOpen(true);
  };

  const handleNewCategorieModalOpenning = profit => {
    setProfit(profit);
    setNewCategorieDialogOpen(true);
  };

  const handleRenameCategorieModalOpenning = () => {
    const { name, id } = selectedCategorie;

    setRenameCategorieDialogOpen(true);
  };

  const handleRemoveCategorieModalOpenning = () => {
    const { name, id } = selectedCategorie;

    setRemoveCategorieDialogOpen(true);
  };

  const { show } = useContextMenu({
    id: "produitsMenu"
  });

  const { show: showCategorieMenu } = useContextMenu({
    id: "categoriesMenu"
  });

  const displayCategorieMenu = (e, categorie) => {
    setSelectedCategorie({
      id: categorie.id,
      name: categorie.name
    });
    setHoveringCategorie(categorie.id);

    showCategorieMenu(e, {
      position: {
        x: e.pageX,
        y: e.pageY
      }
    });
  };

  const Categorie = ({ categorie, content }) => {
    const { id, name } = categorie;
    return (
      <li>
        <span
          onMouseOver={() => setHoveringCategorie(id)}
          onClick={e => displayCategorieMenu(e, categorie)}
          className={`categorie ${hoveringCategorie === id ? "hover" : ""}`}
        >
          {name}
          <span className="edit">
            <FontAwesomeIcon icon={faGear} />
          </span>
        </span>
        {<ul>{content}</ul>}
      </li>
    );
  };

  const authContext = useAuthState(); //read user de
  const { userDetails = {} } = authContext;
  const {
    id: utilisateurId,
    login,
    email,
    token,
    entreprises = []
  } = userDetails;

  console.log({ entreprises });
  const entreprise = entreprises[0].entrepriseId;

  return (
    <Query query={getPlan} variables={{ entreprise }}>
      {({
        loading: loadingPlan,
        error: errorPlan,
        data: dataPlan = {},
        refetch: refetchPlan
      }) => {
        const lossCategories = [];
        const profitCategories = [];
        let planId;

        if (dataPlan.getPlan) {
          planId = dataPlan.getPlan.id;
          dataPlan.getPlan.categories.forEach(categorie => {
            const { produits = [] } = categorie;
            let contentProduits = [];

            if (produits.length)
              produits.forEach(produit => {
                contentProduits.push(
                  <li
                    className={`produit ${
                      hoveringProduit === produit.id ? "hover" : ""
                    }`}
                    onClick={e => displayProduitMenu(e, produit)}
                  >
                    {produit.name}
                  </li>
                );
              });

            contentProduits.push(
              <li
                className="addProduit"
                onClick={() => handleNewProduitModalOpenning({ categorie })}
              >
                +<span className="addLabel">Ajouter</span>{" "}
              </li>
            );

            if (categorie.profit)
              profitCategories.push(
                <Categorie categorie={categorie} content={contentProduits} />
              );
            else
              lossCategories.push(
                <Categorie categorie={categorie} content={contentProduits} />
              );
          });
        }

        const displayProduitMenu = (e, produit) => {
          setSelectedProduit({
            id: produit.id,
            name: produit.name,
            categorie: produit.categorie.id
          });
          setHoveringProduit(produit.id);

          show(e, {
            position: {
              x: e.pageX,
              y: e.pageY
            }
          });
        };

        return (
          <div>
            <Menu
              onHidden={() => setHoveringCategorie(null)}
              id="categoriesMenu"
            >
              <Item
                data="unique"
                onClick={() => handleRenameCategorieModalOpenning()}
              >
                <FontAwesomeIcon icon={faTag} size={"sm"} />
                &nbsp;Renommer
              </Item>
              <Item
                data="unique"
                onClick={() => handleRemoveCategorieModalOpenning()}
              >
                <FontAwesomeIcon icon={faTrashAlt} size={"sm"} />
                &nbsp;Supprimer
              </Item>
            </Menu>
            <Menu onHidden={() => setHoveringProduit(null)} id="produitsMenu">
              <Item
                data="unique"
                onClick={() => handleRenameProduitModalOpenning()}
              >
                <FontAwesomeIcon icon={faTag} size={"sm"} />
                &nbsp;Renommer
              </Item>
              <Item
                data="unique"
                onClick={() => handleRemoveProduitModalOpenning()}
              >
                <FontAwesomeIcon icon={faTrashAlt} size={"sm"} />
                &nbsp;Supprimer
              </Item>
            </Menu>{" "}
            <NewProduitModal
              open={newProduitDialogOpen}
              setOpen={setNewProduitDialogOpen}
              categorieName={categorieName}
              categorieId={categorieId}
              loading={newProduitLoading}
              onSubmitAction={({ produitName, categorieId }) =>
                _mutateAddProduit({
                  planId,
                  produitName,
                  categorieId,
                  refetch: refetchPlan
                })
              }
            />
            <NewCategorieModal
              open={newCategorieDialogOpen}
              setOpen={setNewCategorieDialogOpen}
              categorieId={categorieId}
              onSubmitAction={({ categorieName }) =>
                _mutateAddCategorie({
                  planId,
                  categorieName,
                  refetch: refetchPlan
                })
              }
              loading={newCategorieLoading}
            />
            <RenameProduitModal
              open={renameProduitDialogOpen}
              setOpen={setRenameProduitDialogOpen}
              produitName={selectedProduit.name}
              produitId={selectedProduit.id}
              categorieId={selectedProduit.categorie}
              loading={renameProduitLoading}
              onSubmitAction={({ produitNewName, categorieId, produitId }) =>
                _mutateRenameProduit({
                  planId,
                  produitNewName,
                  produitId,
                  categorieId,
                  refetch: refetchPlan
                })
              }
            />
            <RenameCategorieModal
              open={renameCategorieDialogOpen}
              setOpen={setRenameCategorieDialogOpen}
              categorieName={selectedCategorie.name}
              categorieId={selectedCategorie.id}
              loading={renameCategorieLoading}
              onSubmitAction={({ categorieNewName, categorieId }) =>
                _mutateRenameCategorie({
                  planId,
                  categorieNewName,
                  categorieId,
                  refetch: refetchPlan
                })
              }
            />
            <Confirm
              open={removeProduitDialogOpen}
              setOpen={setRemoveProduitDialogOpen}
              variables={{
                produitId: selectedProduit.id,
                categorieId: selectedProduit.categorie
              }}
              caption={`Voulez-vous vraiment supprimer ${selectedProduit.name} ?`}
              onSubmitAction={({ produitId, categorieId }) =>
                _mutateRemoveProduit({
                  planId,
                  produitId,
                  categorieId,
                  refetch: refetchPlan
                })
              }
            />{" "}
            <Confirm
              open={removeCategorieDialogOpen}
              setOpen={setRemoveCategorieDialogOpen}
              variables={{
                categorieId: selectedCategorie.id
              }}
              caption={`Voulez-vous vraiment supprimer ${selectedCategorie.name} ?`}
              onSubmitAction={({ categorieId }) =>
                _mutateRemoveCategorie({
                  planId,
                  categorieId,
                  refetch: refetchPlan
                })
              }
            />
            <h1 className="dashboardTitle">Plan d'exploitation</h1>
            <h4>
              Profit
              <Badge
                bg="primary"
                className="addCategorie float-end"
                onClick={() => handleNewCategorieModalOpenning(true)}
              >
                <span className="plus">+</span>Ajouter
              </Badge>
            </h4>
            <ul className="planExploitation">{profitCategories}</ul>
            <h4>
              Pertes{" "}
              <Badge
                bg="primary"
                className="addCategorie float-end"
                onClick={() => handleNewCategorieModalOpenning(false)}
              >
                <span className="plus">+</span> Ajouter
              </Badge>
            </h4>
            <ul className="planExploitation">{lossCategories}</ul>
          </div>
        );
      }}
    </Query>
  );
}

export default compose(
  graphql(addProduit, {
    name: "addProduit"
  }),
  graphql(removeProduit, {
    name: "removeProduit"
  }),
  graphql(renameProduit, {
    name: "renameProduit"
  }),
  graphql(addCategorie, {
    name: "addCategorie"
  }),
  graphql(removeCategorie, {
    name: "removeCategorie"
  }),
  graphql(renameCategorie, {
    name: "renameCategorie"
  })
)(PlanExploitation);
